module.exports = __webpack_public_path__ + "static/media/161007-DSC04958-11_Small.a278d489.jpg";